import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = ["name", "disabled", "checked"];
import { computed, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseCheckbox',
    props: {
        modelValue: {
            type: [Boolean, Array],
            required: true
        },
        checkboxClass: {
            type: String,
            default: 'ml-4'
        },
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        },
        shadow: {
            type: Boolean,
            default: true
        },
        border: {
            type: Boolean,
            default: true
        },
        dark: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: null
        },
        hoverBgClass: {
            type: String,
            default: ''
        },
        textClass: {
            type: String,
            default: 'text-red'
        }
    },
    emits: ["update", "update:modelValue", "update:listObject"],
    setup(__props, { expose, emit }) {
        const props = __props;
        // TODO: please add emits values definition
        const checkbox = ref(null);
        const isHovering = ref(false);
        const computedModel = computed(() => {
            if (props.modelValue === null) {
                return [];
            }
            return props.modelValue;
        });
        const checked = computed(() => {
            if (Array.isArray(computedModel.value)) {
                return computedModel.value.includes(props.value);
            }
            return Boolean(computedModel.value);
        });
        const update = () => {
            const checked = checkbox.value.checked;
            if (!Array.isArray(computedModel.value)) {
                emit('update', checked);
                emit('update:modelValue', checked);
                return;
            }
            if (checked) {
                emit('update', [...computedModel.value, props.value]);
                emit('update:modelValue', [...computedModel.value, props.value]);
            }
            else {
                emit('update', computedModel.value.filter((value) => value !== props.value));
                emit('update:modelValue', computedModel.value.filter((value) => value !== props.value));
            }
            emit('update:listObject', {
                id: props.value,
                checked,
                label: props.label
            });
        };
        const uncheck = () => {
            checkbox.value.checked = false;
            emit('update:listObject', {
                id: props.value,
                checked: false,
                label: props.label
            });
        };
        expose({
            uncheck
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("label", {
                class: _normalizeClass(["rounded inline-flex items-center transition-all duration-150 cursor-pointer", [
                        {
                            'border border-danger-700': __props.error && !__props.disabled,
                            'border border-solid border-gray-300 bg-gray-100 cursor-not-allowed': __props.disabled,
                            'bg-white border-gray-300 border border-solid shadow hover:shadow-md hover:border-gray-400': !__props.disabled && !__props.dark && (__props.border || __props.shadow),
                            'border border-solid bg-white border-primary-500 outline-primary-500': _unref(checked) && !__props.disabled && !__props.loading && !__props.error && !__props.dark && (__props.border || __props.shadow),
                            'bg-danger-500 shadow': _unref(checked) && !__props.disabled && __props.dark,
                            'bg-white outline-none': !__props.border && !__props.shadow,
                            'shadow-none': !__props.shadow,
                            'border-none': !__props.border,
                            'border-gray-800 border border-solid shadow hover:shadow-md hover:border-gray-400 bg-gray-900': !__props.disabled && __props.dark
                        },
                        isHovering.value ? __props.hoverBgClass : ''
                    ]]),
                onMouseover: _cache[0] || (_cache[0] = ($event) => (isHovering.value = true)),
                onMouseout: _cache[1] || (_cache[1] = ($event) => (isHovering.value = false))
            }, [
                _createElementVNode("input", _mergeProps({
                    ref_key: "checkbox",
                    ref: checkbox,
                    class: ["form-checkbox outline-none", [
                            __props.disabled || __props.loading ? 'cursor-not-allowed' : 'cursor-pointer',
                            __props.dark ? 'text-danger-900 bg-gray-800' : '',
                            __props.checkboxClass
                        ]],
                    type: "checkbox",
                    name: __props.value
                }, _ctx.$attrs, {
                    disabled: __props.disabled || __props.loading,
                    checked: _unref(checked),
                    onChange: update
                }), null, 16, _hoisted_1),
                (!_ctx.$slots.customLabel)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["p-3 text-base", [{ 'text-white': __props.dark, 'text-transparent bg-gray-200 rounded-lg h-5 m-3': __props.loading }, __props.textClass]])
                    }, _toDisplayString(__props.label), 3))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "customLabel")
            ], 34));
        };
    }
});
